<template>

  <a-dropdown autoAdjustOverflow placement="bottomRight">
    <template #overlay>
      <a-menu>
        <a-menu-item-group>
          <template #title>
            <div class="menu-title">
              <span class="menu-title-up">{{ userInfo.nickname }}</span>
              <!--              <span class="menu-title-bottom">最后登录：{{ last_login }}</span>-->
            </div>
          </template>
          <a-menu-divider/>
          <a-menu-item @click="visible = !visible" key="3">
            <template #icon>
              <v-icon icon="EditOutlined" :size="false"/>
            </template>
            修改密码
          </a-menu-item>
          <a-menu-item @click="quitSystem" key="4">
            <template #icon>
              <v-icon icon="LogoutOutlined" :size="false"/>
            </template>
            退出登录
          </a-menu-item>

        </a-menu-item-group>
      </a-menu>
    </template>
    <div class="userInfo">
      <div class="avatar">{{ !userInfo.nickname ? "龙" : userInfo.nickname.charAt(0) }}</div>
      <span class="nickname">{{ userInfo.nickname }}</span>
      <div class="online-status">
        <span class="online-icon" :class="{offline:userInfo.GameStatus !== 1}"></span>
        <span class="online-text">游戏{{ ['离线', '在线', '非正常下线'][userInfo.GameStatus] }}</span>
      </div>
    </div>
  </a-dropdown>


  <!-- 修改密码 -->
  <v-form
      v-model:visible="visible"
      :dataSource="need"
      :form="form"
      :init="api.login.password"
      :after="()=>quitSystem(false)"
      message="修改成功！"
      :witdh="450"
      :showBorder="false"
      :before="before"
      :hasTable="false"
      name="info_modify"
      title="修改登录密码"/>

</template>

<script setup>
/**
 * 顶部导航用户信息组件
 * */
import user from "@/stores/user";
import api from "@/service/api"
import quitSystem from "@/service/quit-system";
import load from "@/common/load";
import {ref} from "vue";
import {store} from "@/common";

/** @type user */
const userInfo = user();


/* 数据模板 */
const need = store({
  oldpassword: null,
  password: null,
  repass: null
});


/* 新用户添加模板 */
const form = [
  {
    key: 'oldpassword',
    type: "input-password",
    label: "原密码",
    attr: {
      required: true,
      placeholder: "请输入原登录密码",
    }
  },
  {
    key: 'password',
    type: "input-password",
    label: "新密码",
    attr: {
      required: true,
      placeholder: "请输入新的登录密码",
    }
  },
  {
    key: 'repass',
    type: "input-password",
    label: "确认密码",
    attr: {
      required: true,
      placeholder: "请输入新的登录密码",
    }
  },
];

const visible = ref(false); //是否显示修改框

/* 验证两次密码是否一致 */
const before = () => {
  if (need.data.password !== need.data.repass) {
    load.error("两次密码输入不一致！");
    return false;
  } else {
    return true;
  }
}


</script>

<style lang="scss" scoped>

.userInfo {
  height: 60px;
  display: flex;
  align-items: center;
  margin-right: 36px;
  cursor: pointer;
  position: relative;

  .nickname {
    margin: 0 12px;
    font-size: 14px;
    white-space: nowrap;
    color: $admin-header-color;
  }


  .avatar {
    @include flex-center;
    justify-content: center;
    font-size: 17px;
    color: white;
    border-radius: 50%;
    background-color: $primary-color;
    width: 36px;
    height: 36px;
  }


  .version {
    display: inline;
    padding: 0 3px;
    border: 1px solid $border-2;

    line-height: normal;
    white-space: nowrap;
    font-size: 12px;
    color: $text-color-4;
    border-radius: 4px;
  }

  .online-status {

    .online-icon {
      display: inline-block;
      width: 7px;
      height: 7px;
      background-color: #2acd72;
      border-radius: 50%;
    }

    .offline {
      background-color: red;
    }

    .online-text {
      margin-left: 3px;
      font-size: $font-size-5;
    }
  }

  /*  .credit {
      @include flex-center;
      margin-left: 6px;
      gap: 3px;

      .remain, .text {
        font-size: $font-size-4;
        padding-bottom: 2px;
      }
    }*/
}


:deep(.ant-dropdown-menu-item) {
  margin: $admin-header-menu-margin 0;
}


.menu-title {
  display: flex;
  flex-direction: column;
  margin: 0 $admin-header-menu-margin;
  min-width: 180px;

  .menu-title-up {
    font-weight: bold;
    color: $text-color-3;
  }

  .menu-title-bottom {
    margin-top: $admin-header-menu-margin;
    font-size: $font-size-6;
  }

  .red {
    font-weight: bold;
    color: red;
  }
}

</style>